<template>
  <div class="text-dark">
    <ChooseSalarySystem
      v-if="isAllLoaded && !salarySystem"
      :schoolId="schoolId"
    ></ChooseSalarySystem>

    <div class="d-sub-header" v-if="!isInOpusModal">
      <p
        v-for="item in menu"
        :key="item.key"
        class="d-sub-header__link"
        :class="{'d-sub-header__link--active': activePage === item.key}"
        @click="setActivePage(item.key)"
      >
        {{ item.label }}
      </p>
    </div>

    <template v-if="isAllLoaded && activeTab">
      <component
        :is="activeTab.component"
        v-bind="getPropsFor(activeTab.key)"
        @select="onTemplateSelected"
        @onTemplateCreated="onTemplateCreated"
        @onTemplateUpdated="onTemplateUpdated"
        @onTemplateDeleted="onTemplateDeleted"
        @approveState="$emit('approveState', $event)"
      ></component>
    </template>
  </div>
</template>

<script>
import SupplementsList from './SupplementsList.vue'
import Loader from '../common/Loader.vue'
import ChooseSalarySystem from './ChooseSalarySystem.vue'
import CostCenters from '../Salary/SchoolSettings/CostCenters.vue'
import SalaryCodes from '../Salary/SchoolSettings/SalaryCodes.vue'

export default {
  components: {
    CostCenters,
    SalaryCodes,
    ChooseSalarySystem,
    SupplementsList,
    Loader
  },
  props: {
    isInOpusModal: {
      type: Boolean,
      default: false
    },
    beregningType: {
      type: String,
      default: null
    },
    sendToOpusTrigger: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      activePage: 'tillæg'
    }
  },
  computed: {
    menu () {
      let menu = [
        {key: 'tillæg', label: 'Tillæg', component: 'SupplementsList'},
        {key: 'lønkoder', label: 'Lønkoder', component: 'SalaryCodes'},
        {key: 'omkostningssteder', label: 'Omkostningssteder', component: 'CostCenters'}
      ]
      return menu
    },
    salarySystem () {
      return this.$store.getters.salarySystem
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    schoolYearId () {
      return this.$store.getters.schoolYearId
    },
    isAllLoaded () {
      return this.schoolId && this.schoolYearId && this.schoolYear
    },
    // Hvis du allerede har valgte medarbejdere et andet sted i store, kan du mappe dem her.
    // Ellers bliver det bare en tom liste, som komponenten håndterer fint.
    selectedEmploymentIds () {
      if (this.$store && this.$store.getters && this.$store.getters.selectedEmploymentIds) {
        return this.$store.getters.selectedEmploymentIds
      }
      return []
    },
    activeTab () {
      const match = this.menu.filter(m => m.key === this.activePage)
      return match.length > 0 ? match[0] : null
    }
  },
  methods: {
    setActivePage (page) {
      this.activePage = page
    },
    getPropsFor (key) {
      if (key === 'tillæg') {
        return {
          schoolId: this.schoolId,
          schoolYear: this.schoolYear,
          schoolYearId: this.schoolYearId,
          isInOpusModal: this.isInOpusModal,
          beregningType: this.beregningType,
          sendToOpusTrigger: this.sendToOpusTrigger
        }
      }
      if (key === 'lønkoder') {
        return {
          isInSchoolSalarySettings: true
        }
      }
      if (key === 'omkostningssteder') {
        return {
          isInSchoolSalarySettings: true
        }
      }
      if (key === 'lønskabeloner') {
        return {
          selectedEmploymentIds: this.selectedEmploymentIds
        }
      }
      return {}
    },

    // Event handlers fra EmploymentTemplatesTable (kan tilpasses)
    onTemplateSelected (tpl) {
      // Propager evt. videre op hvis parent skal gøre noget
      this.$emit('template-selected', tpl)
    },
    onTemplateCreated () {
      this.$emit('template-created')
    },
    onTemplateUpdated () {
      this.$emit('template-updated')
    },
    onTemplateDeleted () {
      this.$emit('template-deleted')
    }
  }
}
</script>

<style scoped>
.do-margin-grid {
  margin: -1rem;
}

.d-sub-header {
  height: 40px;
  border-bottom: solid 1px #CCCCCC;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 10px;
}

.d-sub-header__link {
  font-weight: bold;
  margin: 0 20px;
  display: flex;
  align-items: center;
  font-size: 11px;
  color: #3e4450;
  opacity: 0.7;
  text-transform: uppercase;
  border-bottom: 2px solid transparent;
  border-top: 2px solid transparent;
  cursor: pointer;
}

.d-sub-header__link--active {
  opacity: 1;
  border-bottom: 2px solid #468AD7;
  transition: all 0.15s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// Supplements.vue?54b41d8f